// @flow
import React from "react";

import SectionHeader from "./commons/SectionHeader";
import Section from "./commons/Section";
import CoverPic from "./commons/CoverPic";
import { THEME_LINK_STYLE } from "./commons/theme";

const PIC_STYLE = { flex: 1 };

const References = () => {
  return (
    <div style={{}}>
      <SectionHeader>Nos références</SectionHeader>
      <CoverPic src="vignes_pluie.jpg" />
      <Section>
        <div style={{ textAlign: "justify", margin: 20 }}>
          On parle de nous :
          <ul>
            <li>Sélection dans le guide Gault et Millau 2021</li>
            <li>
              Sélection{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={THEME_LINK_STYLE}
                href="http://www.guide-veron-champagne.fr/champagne-villepin-brut-vignoble/"
              >
                Guide Véron 2015, 2016, 2017, 2018 et 2019
              </a>
            </li>
            <li>Sélection de l'œnothèque du syndicat des vignerons 2019</li>
            <li>
              En finale des{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={THEME_LINK_STYLE}
                href="http://www.lesjeunestalentsduchampagne.com/edition-2015/les-finalistes/"
              >
                jeunes talents du champagne 2015
              </a>{" "}
              (
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={THEME_LINK_STYLE}
                href="https://www.jeunestalents.tv/JEUNES-TALENTS-DU-CHAMPAGNE-2015-Bruno-De-Villepin-Champagne-De-Villepin-Categorie-Assemblage_v2266.html"
              >
                interview
              </a>
              )
            </li>
            <li>
              Médaille d'or{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={THEME_LINK_STYLE}
                href="https://prixplaisir.bettanedesseauve.com/EPP_liste_gagnants_or-argent-bronze.pdf"
              >
                Prix Plaisir Bettane+Desseauve 2019
              </a>
            </li>
          </ul>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            textAlign: "center",
          }}
        >
          <div style={PIC_STYLE}>
            <img
              src="viticulutredurable.png"
              alt="Label viticulture durable"
              style={{ width: 200, height: 200 }}
            />
          </div>
          <div style={PIC_STYLE}>
            <img
              src="hautevaleurenvironnementale.png"
              alt="label haute valeur environnementale"
              style={{ width: 200, height: 200 }}
            />
          </div>
          {/* <div style={PIC_STYLE}>
            <img
              src="prixplaisir.png"
              alt="Médaille d'or Prix Plaisir Bettane+Desseauve 2019"
              style={{ width: 200, height: 200 }}
            />
          </div> */}
          <div style={PIC_STYLE}>
            <img
              src="gaultmillau.png"
              alt="Guide Gault et Millau 2021"
              style={{ width: 200, height: 200 }}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default References;



// WEBPACK FOOTER //
// ./src/References.js